module.exports = __webpack_public_path__ + "img/12.e7a0b10c.jpg";